import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { embeddedDutiesAware, getDutyAndTaxText } from 'base/lib/embedded_duties_aware'

import CloseIcon from 'base/components/layout/close_icon'
import CheckmarkIcon from 'base/components/icons/checkmark_icon'

export class EmbeddedDutiesModal extends React.Component {
  static propTypes = {
    platform: PropTypes.string.isRequired,
    dismissDutiesModal: PropTypes.func.isRequired,
    wait: PropTypes.number,
  }

  static defaultProps = {
    platform: 'desktop',
  }

  state = {
    open: this.props.wait ? false : true,
  }

  AUTO_CLOSE_TIMEOUT = 15000

  componentDidMount() {
    if (this.props.wait) {
      setTimeout(() => {
        this.openModal()
        this.closeAfterTimeout()
      }, this.props.wait)
    }
  }

  closeAfterTimeout = () => {
    setTimeout(() => {
      this.handleClose()
    }, this.AUTO_CLOSE_TIMEOUT)
  }

  handleClose = () => {
    this.setState({ open: false })
    this.props.dismissDutiesModal()
  }

  openModal = () => {
    this.setState({ open: true })
  }

  renderCheckMark() {
    return <CheckmarkIcon size="13" color="#5d5d5d" className="check-mark" />
  }

  renderDutiesDisclaimer() {
    return (
      <React.Fragment>
        <h3 className="embedded-duties__title">
          {`Shopping in ${this.props.localization.country_name} is now easier`}
        </h3>

        {this.props.platform === 'desktop' && (
          <CloseIcon className="embedded-duties__close-button" handleClose={this.handleClose} />
        )}

        <div className="embedded-duties__bullets">
          <ul>
            {this.props.intlFirstOrderFreeShippingEnabled && (
              <li>{this.renderCheckMark()}Free shipping on first order</li>
            )}
            <li>{this.renderCheckMark()}Easy returns</li>
            <li>
              {this.renderCheckMark()}
              {getDutyAndTaxText(this.props)}
            </li>
          </ul>
        </div>
      </React.Fragment>
    )
  }

  render() {
    const platformClassName = `embedded-duties--${this.props.platform}`

    return (
      <div
        className={classNames('embedded-duties', platformClassName, {
          'embedded-duties--active': this.state.open,
        })}
      >
        <div className="embedded-duties__container">
          {this.renderDutiesDisclaimer()}
          {this.props.children}
        </div>
      </div>
    )
  }
}

export default embeddedDutiesAware(EmbeddedDutiesModal)
